import Api from "@/services/Index";

const getFormData = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/form");
};

const store = async (data, config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff-reimbursement-forms", data, config);
};

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms", config);
};

const getMyRequests = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/my-requests", config);
};

const getMyRequest = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/my-requests/" + id);
};

const downloadMyRequestFile = async (uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/my-requests/download/" + uuid, {
        responseType: "arraybuffer",
    });
};

const getMyRequestApprovalStepsReport = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/my-requests/approval-steps-report/" + id, {
        responseType: "arraybuffer",
    });
};

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/" + id);
};

const sendToRequesterReview = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff-reimbursement-forms/send-to-requester-review", data);
};

const sendToCfoOrPresidentReview = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff-reimbursement-forms/send-to-cfo-or-president-review", data);
};

const purchaseOfficerApproval = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staff-reimbursement-forms/purchase-officer-approval", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

const download = async (uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/download/" + uuid, {
        responseType: "arraybuffer",
    });
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/excel-export", {
        ...config,
        responseType: "arraybuffer",
    });
};

const getApprovalStepsReport = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/staff-reimbursement-forms/approval-steps-report/" + id, {
        responseType: "arraybuffer",
    });
};

export default {
    getFormData,
    store,
    getAll,
    getMyRequests,
    getMyRequest,
    downloadMyRequestFile,
    getMyRequestApprovalStepsReport,
    get,
    sendToRequesterReview,
    sendToCfoOrPresidentReview,
    purchaseOfficerApproval,
    download,
    excelExport,
    getApprovalStepsReport,
};
